module.exports = __webpack_public_path__ + "img/Must-Have-Accessories.8d2e2375.jpg";